import { faqConstants } from "../constants/faqConstants";

const initialState = {
  sending: false,
  sended: false,
  error: "",
  addFaqResponse: {},
  faqDetails: {},
  deleteFaqResponse: {},
  deletedFaq: false,
  deletingFaq: false,
  receivedFaqDetails: false,
  receivingFaqDetails: false,
  faqDetails: {},
  receivedFaqList: false,
  receivingFaqList: false,
  faqList: {},
  updateFaqResponse: {},
  receivedFaqFrontendDetails: false,
  receivingFaqFrontendDetails: false,
  faqFrontendDetails: {},
  sendingFaqVote: false,
  sendedFaqVote: false,
  addFaqVoteResponse: {},
  receivedFaqVoteDetails: false,
  receivingFaqVoteDetails: false,
  faqVoteDetails: {}
};

export default function faqReducer(state = initialState, action) {
  switch (action.type) {
    case faqConstants.ADD_FAQ_REQUEST:
      return {
        ...state,
        sending: true,
        sended: false
      };
    case faqConstants.ADD_FAQ_SUCCESS:
      return {
        ...state,
        sending: false,
        sended: true,
        addFaqResponse: action.data,
        error: ""
      };
    case faqConstants.ADD_FAQ_FAILURE:
      return {
        ...state,
        sended: false,
        sending: false,
        error: action.error
      };
    case faqConstants.GET_FAQ_DETAILS_REQUEST:
      return {
        ...state,
        receivedDetails: false,
        receivingDetails: true
      };
    case faqConstants.GET_FAQ_DETAILS_SUCCESS:
      return {
        ...state,
        receivedDetails: true,
        receivingDetails: false,
        faqDetails: action.data.data
      };
    case faqConstants.GET_FAQ_DETAILS_FAILURE:
      return {
        ...state,
        receivingDetails: false,
        receivedDetails: false,
        error: action.error
      };
    case faqConstants.DELETE_FAQ_REQUEST:
      return {
        ...state,
        deletedFaq: false,
        deletingFaq: true,
        error: ""
      };
    case faqConstants.DELETE_FAQ_SUCCESS:
      return {
        ...state,
        deletedFaq: true,
        deletingFaq: false,
        deleteFaqResponse: action.data,
        error: ""
      };
    case faqConstants.DELETE_FAQ_FAILURE:
      return {
        ...state,
        deletedFaq: false,
        deletingFaq: false,
        error: action.error
      };
    case faqConstants.GET_FAQ_LIST_REQUEST:
      return {
        ...state,
        receivedFaqList: false,
        receivingFaqList: true
      };
    case faqConstants.GET_FAQ_LIST_SUCCESS:
      return {
        ...state,
        receivedFaqList: true,
        receivingFaqList: false,
        faqList: action.data.data
      };
    case faqConstants.GET_FAQ_LIST_FAILURE:
      return {
        ...state,
        receivedFaqList: false,
        receivingFaqList: false,
        error: action.error
      };
    case faqConstants.UPDATE_FAQ_DETAILS_REQUEST:
      return {
        ...state,
        sending: false,
        sended: true
      };
    case faqConstants.UPDATE_FAQ_DETAILS_SUCCESS:
      return {
        ...state,
        sending: false,
        sended: true,
        updateFaqResponse: action.data
      };
    case faqConstants.UPDATE_FAQ_DETAILS_FAILURE:
      return {
        ...state,
        sending: false,
        sended: false,
        error: action.error
      };
    case faqConstants.GET_FAQ_FRONTEND_DETAILS_REQUEST:
      return {
        ...state,
        receivedFaqFrontendDetails: false,
        receivingFaqFrontendDetails: true
      };
    case faqConstants.GET_FAQ_FRONTEND_DETAILS_SUCCESS:
      return {
        ...state,
        receivedFaqFrontendDetails: true,
        receivingFaqFrontendDetails: false,
        faqFrontendDetails: action.data.data
      };
    case faqConstants.GET_FAQ_FRONTEND_DETAILS_FAILURE:
      return {
        ...state,
        receivingFaqFrontendDetails: false,
        receivedFaqFrontendDetails: false,
        error: action.error
      };
    case faqConstants.ADD_FAQ_VOTE_REQUEST:
      return {
        ...state,
        sendingFaqVote: true,
        sendedFaqVote: false
      };
    case faqConstants.ADD_FAQ_VOTE_SUCCESS:
      return {
        ...state,
        sendingFaqVote: false,
        sendedFaqVote: true,
        addFaqVoteResponse: action.data,
        error: ""
      };
    case faqConstants.ADD_FAQ_VOTE_FAILURE:
      return {
        ...state,
        sendedFaqVote: false,
        sendingFaqVote: false,
        error: action.error
      };
    case faqConstants.GET_FAQ_VOTE_DETAILS_REQUEST:
      return {
        ...state,
        receivedFaqVoteDetails: false,
        receivingFaqVoteDetails: true
      };
    case faqConstants.GET_FAQ_VOTE_DETAILS_SUCCESS:
      return {
        ...state,
        receivedFaqVoteDetails: true,
        receivingFaqVoteDetails: false,
        faqVoteDetails: action.data
      };
    case faqConstants.GET_FAQ_VOTE_DETAILS_FAILURE:
      return {
        ...state,
        receivingFaqVoteDetails: false,
        receivedFaqVoteDetails: false,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/faqReducer.js